var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bin-tree-org-wrap" }, [
    _c(
      "div",
      {
        staticClass: "bin-tree-org",
        class: { horizontal: _vm.horizontal, collapsable: _vm.collapsable }
      },
      [
        _c("tree-node", {
          attrs: {
            data: _vm.data,
            "children-key": _vm.childrenKey,
            horizontal: _vm.horizontal,
            "label-style": _vm.labelStyle,
            collapsable: _vm.collapsable,
            "label-class-name": _vm.labelClassName
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }